import * as React from 'react';

function SvgLockClosedOutline(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.6, d: "M15.58 9.83V5.58a3.58 3.58 0 10-7.16 0v4.25M17.011 9.83H6.99a2.148 2.148 0 00-2.148 2.148v7.874C4.841 21.04 5.803 22 6.99 22h10.022a2.148 2.148 0 002.148-2.148v-7.874a2.148 2.148 0 00-2.148-2.148z" })));
}

export default SvgLockClosedOutline;
